var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"package_data"}},[_vm._v(" แพ็จเกจ "+_vm._s(_vm.data_stores.package)+" "),_c('br'),_vm._v(" วันหมดอายุ "+_vm._s(_vm.data_stores.expiry_date)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }